import { DocumentReference } from '@angular/fire/firestore';
import firebase from 'firebase';
import { EstudianteInterface } from '../interface/estudiante_interface';


export class Estudiante implements  EstudianteInterface{

    constructor() {
    }
    id: string;
    campoVacioNombre: string;
    campoVacioApellido: string;
    campoVacionDob: string;
    dobDatePicker: any;
    appCreacion: string;
    age: number;
    tutor: DocumentReference<firebase.firestore.DocumentData>[];
    userType: any;
    status: any;
    fullname: any;
    firstname: string;
    lastname: string;
    registrationDate: any;
    dob: any;
    sexo: string;
    roles: any;
    showStudent : boolean;
    showIncription : boolean;
    statusCourseAux : string;
}
